import parse from "html-react-parser";
import { Link } from "@base-ui";
import { isExternalLink, makeUrl } from "utils/links";
import { jsx as _jsx } from "react/jsx-runtime";
export var convertHtmlstringToHtml = function convertHtmlstringToHtml(string) {
  return parse(string, {
    replace: function replace(node) {
      var _node$parent2;
      if (node.name === "a" && node.attribs.href) {
        var _node$parent, _node$prev, _node$next;
        var children = node.children.map(function (child) {
          return child.data;
        });
        var insideList = ((_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.name) === "li";
        var newLine = (((_node$prev = node.prev) === null || _node$prev === void 0 ? void 0 : _node$prev.name) === "br" || !node.prev) && (((_node$next = node.next) === null || _node$next === void 0 ? void 0 : _node$next.name) === "br" || !node.next);
        var linkUrl = makeUrl(node.attribs.href);
        var externalLink = isExternalLink(linkUrl);
        return /*#__PURE__*/_jsx(Link, {
          to: "",
          as: "a",
          href: linkUrl,
          target: externalLink ? "_blank" : undefined,
          style: {
            display: "inline-flex",
            padding: !newLine || insideList ? 0 : "",
            minHeight: !newLine || insideList ? "30px" : "",
            marginLeft: newLine && !insideList ? "-20px" : ""
          },
          children: children
        });
      } else if (((_node$parent2 = node.parent) === null || _node$parent2 === void 0 ? void 0 : _node$parent2.name) === "a") return null;
      return node;
    }
  });
};